<template>
  <div>
    <el-form :inline="false" label-position="top" size="small">
      <el-row :gutter="20">
        <el-col :span="7">
          <el-form-item prop="timeType">
            <template slot="label">
              <div class="selectLabel">
                <el-select v-model="queryForm.params.timeType" :style="IsWidth">
                  <el-option key="1" :label="$t('GlobalSetObj.CreationTime')" :value="1" />
<!--                  <el-option key="2" :label="$t('customerManagements.genterTiem')" :value="2" />-->
                </el-select>
              </div>
            </template>
            <el-date-picker
              v-model="timeValue"
              :clearable="false"
              :default-time="['00:00:00', '23:59:59']"
              :end-placeholder="$t('GlobalSetObj.endDate')"
              :format="$i18n.locale == 'zh' ? zhDate : ptDate"
              :start-placeholder="$t('GlobalSetObj.startDate')"
              range-separator="~"
              style="width: 100%"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--  状态   -->
          <el-form-item :label="$t('GlobalSetObj.status')">
            <el-select
              v-model="queryForm.params.status"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              style="width: 100%"
            >
              <el-option :label="$t('GlobalSetObj.all')" :value="null" />
              <el-option :label="$t('GlobalSetObj.enable')" :value="1" />
              <el-option :label="$t('GlobalSetObj.stop')" :value="0" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!-- 网点所属州 -->
          <el-form-item :label="$t('collectionCenter.stateSite1')">
            <el-select
              v-model="queryForm.params.siteState"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable filterable
              style="width: 100%" size="small"
            >
              <el-option
                v-for="item in stateList"
                :key="item.id"
                :label="item.label"
                :value="item.label"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!-- 城镇类型 -->
          <el-form-item :label="$t('navbar.cityType')">
            <el-select
              v-model="queryForm.params.areaType"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable style="width: 100%" size="small"
            >
              <el-option label="州府(CAPITAL)" :value="1" />
              <el-option label="市区(METROPOLITAN)" :value="2" />
              <el-option label="农村(COUNTRYSIDE)" :value="3" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!-- 时效起点州 -->
          <el-form-item :label="$t('collectionCenter.timelinessStartState')">
            <el-select
              v-model="queryForm.params.agingStartState"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable style="width: 100%" size="small"
            >
              <el-option
                v-for="item1 in stateList"
                :key="item1.id"
                :label="item1.label"
                :value="item1.label"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="15">
          <!--搜索-->
          <el-button
            icon="el-icon-search" size="small" type="primary"
            @click="enterSearch"
          >{{ $t('newOrder.search') }}
          </el-button>
          <!--重置-->
          <el-button
            icon="el-icon-refresh-left" size="small" type="info"
            @click="resetForm()"
          >{{ $t('newOrder.reset') }}
          </el-button>
          <el-button
            size="small" style="margin-bottom: 15px" type="primary"
            @click="addCusTime"
          >{{ $t('uploadFile.addInternalLeadTime') }}
          </el-button>
          <el-button
            size="small" @click="openBulkImport"
          >{{ $t('basicData.BulkImport') }}
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <!--  表格数据  -->
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border
      max-height="600"
      style="width: 100%"
    >
      <el-table-column
        :label="$t('GlobalSetObj.serial')" align="center" type="index"
        width="70"
      />
      <el-table-column
        v-for="item in tableHeaderList"
        :key="item.id"
        :label="item.label"
        :min-width="item.cloWidth"
        :prop="item.prop"
        :show-overflow-tooltip="false"
      >
        <template slot-scope="scope">
          <div
            v-if="item.prop === 'merchantName' && scope.row.merchantName && scope.row.merchantCode"
          >
            <span> {{ scope.row.merchantName }}（{{ scope.row.merchantCode }}） </span>
          </div>
          <div v-else-if="item.prop === 'statusTypeObjName'">
            <el-tag
              v-if="scope.row.status === 0" effect="dark" size="small"
              type="danger"
            >{{ scope.row.statusTypeObjName }}
            </el-tag>
            <el-tag
              v-else effect="dark" size="small"
              type=""
            >{{ scope.row.statusTypeObjName }}
            </el-tag>
          </div>
          <div v-else-if="item.prop === 'slaVersion'">
            <span>{{ scope.row.slaVersionDisplay || (scope.row.slaVersion ? 'V' + Number(scope.row.slaVersion).toFixed(1) : '- -') }}</span>
          </div>
          <div v-else>{{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '- -' }}</div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('newOrder.operation')" align="center" fixed="right"
        width="120"
      >
        <template slot-scope="scope">
          <div style="display: flex; justify-content: space-around; align-items: center">
            <el-tooltip
              :content="$t('customerManagements.viewVersionHistory')"
              class="item"
              effect="dark"
              placement="top"
            >
              <i class="el-icon-time textOperator" @click="viewVersionHistory(scope.row)" />
            </el-tooltip>
            <el-tooltip
              :content="$t('GlobalSetObj.edit')"
              class="item"
              effect="dark"
              placement="top"
            >
              <i class="el-icon-edit textOperator" @click="editMessage(scope.row)" />
            </el-tooltip>
            <el-tooltip
              v-if="scope.row.status === 0"
              :content="$t('GlobalSetObj.enable')"
              class="item"
              effect="dark"
              placement="top"
            >
              <i class="el-icon-circle-check textOperator" @click="updateStatus(scope.row)" />
            </el-tooltip>
            <el-tooltip
              v-else
              :content="$t('GlobalSetObj.stop')"
              class="item"
              effect="dark"
              placement="top"
            >
              <i class="el-icon-remove-outline textOperator1" @click="updateStatus(scope.row)" />
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--  分页  -->
    <el-pagination
      :current-page="queryForm.pageNumber"
      :page-size="queryForm.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="queryForm.total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: 10px 0; float: right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <!-- 新增内部时效 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="cusTimeDialogTitle"
      :visible.sync="addCusTimeDialog"
      width="550px"
      class="dialog-class"
      @close="handleAddCusTimeDialog"
    >
      <el-form
        ref="ruleRef" :model="ruleForm"
        class="rule-box-class"
      >
        <el-row type="flex" style="justify-content: space-between ;flex-wrap: wrap; margin: 20px 20px 0 20px">
          <el-col :span="11">
            <!-- 网点所属州 -->
            <el-form-item
              :label="$t('collectionCenter.stateSite1')"
              prop="siteState"
              :rules="{
                required: true,
                message: $t('collectionCenter.notNull'),
                trigger: ['blur', 'change']
              }"
            >
              <el-select
                v-model="ruleForm.siteState"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable filterable
                style="width: 100%" size="small"
              >
                <el-option
                  v-for="item in stateList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <!-- 时效起点 -->
            <el-form-item
              :label="$t('customerManagements.timeframeStartingPointName')" prop="agingStartType"
              :rules="{
                required: true,
                message: $t('collectionCenter.notNull'),
                trigger: ['blur', 'change']
              }"
            >
              <el-select
                v-model="ruleForm.agingStartType"
                :placeholder="$t('GlobalSetObj.OnlyAreDisplayed')"
                clearable style="width: 100%" size="small"
                @change="clearCode('')"
              >
                <el-option :label="$t('newOrder.StorageTimeOutlets')" :value="1" />
                <el-option :label="$t('collectionCenter.secondaryOrTertiaryArrivalTime')" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="ruleForm.agingStartType !== 1" :span="11">
            <!-- 时效起点州 -->
            <el-form-item
              :label="$t('collectionCenter.timelinessStartState')"
              prop="agingStartState"
              :rules="{
                required: true,
                message: $t('collectionCenter.notNull'),
                trigger: ['blur', 'change']
              }"
            >
              <el-select
                v-model="ruleForm.agingStartState"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable style="width: 100%" size="small"
              >
                <el-option
                  v-for="item1 in stateList"
                  :key="item1.id"
                  :label="item1.label"
                  :value="item1.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="ruleForm.agingStartType !== 1" :span="11">
            <!-- 时效计算模式 -->
            <el-form-item
              :label="$t('collectionCenter.timelinessCalculationMode')"
              prop="agingCalculationMode"
              :rules="{
                required: true,
                message: $t('collectionCenter.notNull'),
                trigger: ['blur', 'change']
              }"
            >
              <el-select
                v-model="ruleForm.agingCalculationMode"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable style="width: 100%" size="small"
              >
                <el-option :label="$t('collectionCenter.earliestArrivalTime')" :value="1" />
                <el-option :label="$t('collectionCenter.latestArrivalTime')" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <!-- 城镇类型 -->
            <el-form-item
              :label="$t('navbar.cityType')" prop="areaType"
              :rules="{
                required: true,
                message: $t('collectionCenter.notNull'),
                trigger: ['blur', 'change']
              }"
            >
              <el-select
                v-model="ruleForm.areaType"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable style="width: 100%" size="small"
              >
                <el-option label="州府(CAPITAL)" :value="1" />
                <el-option label="市区(METROPOLITAN)" :value="2" />
                <el-option label="农村(COUNTRYSIDE)" :value="3" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <!-- 时效时长(H) -->
            <el-form-item
              :label="$t('uploadFile.leadTimeHours')" prop="duration"
              :rules="[
                { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur', 'change'] },
                { pattern: /^[1-9]\d{0,9}$/, message: $t('collectionCenter.inputNum'), trigger: ['blur', 'change'] }
              ]"
            >
              <el-input
                v-model="ruleForm.duration"
                :placeholder="$t('collectionCenter.pleaseInput')"
                style="width: 100%" size="small" clearable
                maxlength="10" show-word-limit
              />
            </el-form-item>
          </el-col>
        </el-row>
        <div
          v-if="cusTimeDialogTitle === $t('uploadFile.addInternalLeadTime')"
        >
          <el-row
            v-for="(item, index) in ruleForm.ruleForm2"
            :key="index"
            type="flex"
            class="row-box-class"
          >
            <div class="el-icon-close closeBtn" @click="removeRow(index)" />
            <el-col :span="11">
              <!-- 网点所属州 -->
              <el-form-item
                :label="$t('collectionCenter.stateSite1')"
                :prop="`ruleForm2.${index}.siteState`"
                :rules="{
                  required: true,
                  message: $t('collectionCenter.notNull'),
                  trigger: ['blur', 'change']
                }"
              >
                <el-select
                  v-model="item.siteState"
                  :placeholder="$t('GlobalSetObj.OnlyAreDisplayed')"
                  clearable filterable
                  style="width: 100%" size="small"
                >
                  <el-option
                    v-for="item1 in stateList"
                    :key="item1.id"
                    :label="item1.label"
                    :value="item1.label"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <!-- 时效起点 -->
              <el-form-item
                :label="$t('customerManagements.timeframeStartingPointName')"
                :prop="`ruleForm2.${index}.agingStartType`"
                :rules="{
                  required: true,
                  message: $t('collectionCenter.notNull'),
                  trigger: ['blur', 'change']
                }"
              >
                <el-select
                  v-model="item.agingStartType"
                  :placeholder="$t('GlobalSetObj.OnlyAreDisplayed')"
                  clearable style="width: 100%" size="small"
                  @change="clearCode(index)"
                >
                  <el-option :label="$t('newOrder.StorageTimeOutlets')" :value="1" />
                  <el-option :label="$t('collectionCenter.secondaryOrTertiaryArrivalTime')" :value="2" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="item.agingStartType !== 1" :span="11">
              <!-- 时效起点州 -->
              <el-form-item
                :label="$t('collectionCenter.timelinessStartState')"
                :prop="`ruleForm2.${index}.agingStartState`"
                :rules="{
                  required: true,
                  message: $t('collectionCenter.notNull'),
                  trigger: ['blur', 'change']
                }"
              >
                <el-select
                  v-model="item.agingStartState"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable style="width: 100%" size="small"
                >
                  <el-option
                    v-for="item1 in stateList"
                    :key="item1.id"
                    :label="item1.label"
                    :value="item1.label"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="item.agingStartType !== 1" :span="11">
              <!-- 时效计算模式 -->
              <el-form-item
                :label="$t('collectionCenter.timelinessCalculationMode')"
                :prop="`ruleForm2.${index}.agingCalculationMode`"
                :rules="{
                  required: true,
                  message: $t('collectionCenter.notNull'),
                  trigger: ['blur', 'change']
                }"
              >
                <el-select
                  v-model="item.agingCalculationMode"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable style="width: 100%" size="small"
                >
                  <el-option :label="$t('collectionCenter.earliestArrivalTime')" :value="1" />
                  <el-option :label="$t('collectionCenter.latestArrivalTime')" :value="2" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <!-- 城镇类型 -->
              <el-form-item
                :label="$t('navbar.cityType')"
                :prop="`ruleForm2.${index}.areaType`"
                :rules="{
                  required: true,
                  message: $t('collectionCenter.notNull'),
                  trigger: ['blur', 'change']
                }"
              >
                <el-select
                  v-model="item.areaType"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable style="width: 100%" size="small"
                >
                  <el-option label="州府(CAPITAL)" :value="1" />
                  <el-option label="市区(METROPOLITAN)" :value="2" />
                  <el-option label="农村(COUNTRYSIDE)" :value="3" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <!-- 时效时长(H) -->
              <el-form-item
                :label="$t('uploadFile.leadTimeHours')"
                :prop="'ruleForm2.' + index + '.duration'"
                :rules="[
                  { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur', 'change'] },
                  { pattern: /^[1-9]\d{0,9}$/, message: $t('collectionCenter.inputNum'), trigger: ['blur', 'change'] }
                ]"
              >
                <el-input
                  v-model="item.duration"
                  :placeholder="$t('collectionCenter.pleaseInput')"
                  style="width: 100%" size="small" clearable
                  maxlength="10" show-word-limit
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer footer-stick-class">
        <el-button
          v-if="cusTimeDialogTitle === $t('uploadFile.addInternalLeadTime')"
          size="small" @click="addList"
        >{{ $t('GlobalSetObj.append') }}</el-button>
        <span v-else />
        <div>
          <el-button size="small" @click="cusSubmit(1)">{{ $t('GlobalSetObj.cancel') }}</el-button>
          <el-button
            size="small" type="primary" @click="cusSubmit(2)"
          >{{ $t('GlobalSetObj.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 批量导入 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('basicData.BulkImport')"
      :visible.sync="bulkImportDialog"
      width="550px"
      @close="bulkImportClose"
    >
      <div style="display: flex;justify-content: flex-start;align-items: center; margin-bottom: 10px">
        <div style="color: #00A551; font-size: 15px;margin-right: 20px">
          {{ $t('collectionCenter.pleaseUploadByTemplate') }}
          <br>
          <el-button type="primary" plain @click="downLoadFile">{{ $t('basicData.DownloadTheTemplate') }}</el-button>
        </div>
        <el-upload
          :before-upload="beforeUpload"
          :http-request="uploadFile"
          :file-list="fileList"
          :show-file-list="false"
          :on-remove="handleRemove"
          :limit="1"
          action
          style="margin-top: 20px"
        >
          <el-button type="primary">{{ $t('collectionCenter.Upload') }}</el-button>
        </el-upload>
      </div>
      <div v-if="fileName" class="downLink">
        <div>{{ fileName }}</div>
        <div><i class="el-icon-error" @click="delFile" /></div>
      </div>
      <div slot="footer" style="display: flex;justify-content: flex-end;align-items: center">
        <el-button size="small" @click="fileSubmit(1)">{{ $t('GlobalSetObj.cancel') }}</el-button>
        <el-button
          size="small" type="primary" @click="fileSubmit(2)"
        >{{ $t('GlobalSetObj.confirm') }}
        </el-button>
      </div>
    </el-dialog>

    <!-- 历史版本弹窗 -->
    <el-dialog
      :title="$t('customerManagements.versionHistory')"
      :visible.sync="versionHistoryDialog"
      width="90%"
      @close="closeVersionHistoryDialog"
    >
      <el-table :data="versionHistoryData" border max-height="500">
        <el-table-column :label="$t('GlobalSetObj.serial')" align="center" type="index" width="60" />
        <el-table-column prop="slaVersionDisplay" :label="$t('customerManagements.slaVersion')" min-width="100" />
        <el-table-column prop="createTime" :label="$t('customerManagements.snapshotTime')" min-width="160" />
        <el-table-column
          v-for="item in historyTableHeaderList"
          :key="item.id"
          :label="item.label"
          :min-width="item.cloWidth"
          :prop="item.prop"
          :show-overflow-tooltip="false"
        >
          <template slot-scope="scope">
            <div
              v-if="item.prop === 'merchantName' && scope.row.merchantName && scope.row.merchantCode"
            >
              <span> {{ scope.row.merchantName }}（{{ scope.row.merchantCode }}） </span>
            </div>
            <div v-else-if="item.prop === 'statusTypeObjName'">
              <el-tag
                v-if="scope.row.status === 0" effect="dark" size="small"
                type="danger"
              >{{ scope.row.statusTypeObjName }}
              </el-tag>
              <el-tag
                v-else effect="dark" size="small"
                type=""
              >{{ scope.row.statusTypeObjName }}
              </el-tag>
            </div>
            <div v-else>{{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '- -' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" :label="$t('GlobalSetObj.CreatePeople')" min-width="120" />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  getConfigPage,
  InternalAgingAdd,
  InternalAgingDownloadmodule,
  InternalAgingModify,
  InternalAgingUpdateStatus,
  batchImport,
  getVersionHistoryInternalAging
} from '@/api/customer';
import dayjs from 'dayjs';
import {
  getLgAreaListData
} from '@/api/orderApi';

export default {
  name: 'InternalTime',
  data() {
    return {
      fileList: [],
      fileData: new FormData(),
      fileName: '',
      bulkImportDialog: false,
      stateList: [],
      // 是否格式化成巴西时间
      isTormat: false,
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      timeValue: [],
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        total: 0,
        params: {
          timeType: 1,
          status: null, // 状态：1、启用，2、停用
          siteState: null,
          areaType: null,
          agingStartState: null
        }
      },
      tableData: [],
      versionHistoryDialog: false,
      versionHistoryData: [],
      tableHeaderList: [
        // 创建时间
        { id: 2, label: this.$t('GlobalSetObj.CreationTime'), prop: 'createTime', cloWidth: '160' },
        // 网点所属州
        {
          id: 3,
          label: this.$t('collectionCenter.stateSite1'),
          prop: 'siteState',
          cloWidth: '100'
        },
        // 时效起点
        {
          id: 5,
          label: this.$t('customerManagements.timeframeStartingPointName'),
          prop: 'agingStartPointName',
          cloWidth: '100'
        },
        // 时效起点州
        {
          id: 6,
          label: this.$t('collectionCenter.timelinessStartState'),
          prop: 'agingStartState',
          cloWidth: '100'
        },
        // 时效计算模式
        {
          id: 7,
          label: this.$t('collectionCenter.timelinessCalculationMode'),
          prop: 'agingCalculationModeName',
          cloWidth: '100'
        },
        // 城镇类型
        {
          id: 8,
          label: this.$t('navbar.cityType'),
          prop: 'areaTypeName',
          cloWidth: '100'
        },
        // 时效时长(H)
        {
          id: 9,
          label: this.$t('uploadFile.leadTimeHours'),
          prop: 'duration',
          cloWidth: '100'
        },
        // 状态
        {
          id: 10,
          label: this.$t('GlobalSetObj.status'),
          prop: 'statusTypeObjName',
          cloWidth: '100'
        },
        { id: 12, label: this.$t('customerManagements.slaId'), prop: 'slaId', cloWidth: '140' },
        { id: 13, label: this.$t('customerManagements.slaVersion'), prop: 'slaVersion', cloWidth: '100' },
        // 创建人
        {
          id: 11,
          label: this.$t('GlobalSetObj.CreatePeople'),
          prop: 'createUserName',
          cloWidth: '150'
        },
        // 最新操作时间
        {
          id: 12,
          label: this.$t('customerManagements.newOptionTime'),
          prop: 'updateTime',
          cloWidth: '160'
        },
        // 最新操作人
        {
          id: 13,
          label: this.$t('customerManagements.newOptioner'),
          prop: 'updateUserName',
          cloWidth: '150'
        }
      ],
      customerMerchant: [],
      addCusTimeDialog: false,
      cusTimeDialogTitle: this.$t('uploadFile.addInternalLeadTime'),
      ruleForm: {
        siteState: '',
        agingStartType: '',
        areaType: '',
        duration: '',
        agingStartState: null,
        agingCalculationMode: null,
        ruleForm2: []
      },
      detailData: [],
      weekList: [
        'lkjl',
        this.$t('customerManagements.weekOne'),
        this.$t('customerManagements.weekTwo'),
        this.$t('customerManagements.weekThree'),
        this.$t('customerManagements.weekFoure'),
        this.$t('customerManagements.weekFirtFive'),
        this.$t('customerManagements.weekSix'),
        this.$t('customerManagements.weekSeven')
      ],
      editId: null,
      merchantIdList: []
    };
  },
  computed: {
    historyTableHeaderList() {
      return this.tableHeaderList.filter(item => !['createTime', 'slaVersion'].includes(item.prop));
    },
    IsWidth() {
      return {
        width: this.isTormat ? '180px' : '110px'
      };
    }
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getSearch();
    this.getState();
  },
  methods: {
    openBulkImport() {
      this.bulkImportDialog = true;
    },
    bulkImportClose() {
      this.bulkImportDialog = false;
      this.fileName = '';
      this.fileData = new FormData();
      this.fileList = [];
    },
    downLoadFile() {
      InternalAgingDownloadmodule().then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'table_data.csv'); // 更改为实际的文件名和扩展名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // 清理 URL
      });
    },
    beforeUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1);
      const whiteList = ['csv', 'xlsx', 'XLSX'];
      if (whiteList.indexOf(fileSuffix) === -1) {
        // 上传文件只能是csv、xlsx格式
        this.$message.error(this.$t('collectionCenter.uploadOnlyCsv'));
        return false;
      }
    },
    // 上传文件
    uploadFile(option) {
      // option.file.preventDefault && option.file.preventDefault();
      const files = option.file;
      this.fileData = new FormData();
      this.fileData.append('file', files);
      this.fileName = files.name;
    },
    delFile() {
      this.handleRemove();
    },
    handleRemove() {
      this.fileName = '';
      this.fileData = new FormData();
      this.fileList = [];
    },
    fileSubmit(val) {
      if (val === 1) {
        this.bulkImportClose();
      } else {
        if (this.fileName) {
          const loading = this.$loading({
            fullscreen: true,
            lock: true,
            spinner: 'el-icon-loading',
            text: 'loading...',
            background: 'rgba(250, 250, 250, 0.6)'
          });
          batchImport(this.fileData).then(res => {
            if (res.code === 200) {
              loading.close();
              this.bulkImportClose();
              this.getSearch();
            }
          }).finally(() => {
            loading.close();
          });
        } else {
          this.$message.error(this.$t('customerManagements.pleaseUploadFile'));
        }
      }
    },

    clearCode(val) {
      if (val || val === 0) {
        this.ruleForm.ruleForm2[val].agingStartState = '';
        this.ruleForm.ruleForm2[val].agingCalculationMode = '';
      } else {
        this.ruleForm.agingStartState = '';
        this.ruleForm.agingCalculationMode = '';
      }
    },
    addList() {
      const add = {
        siteState: '',
        agingStartType: '',
        areaType: '',
        duration: '',
        agingStartState: '',
        agingCalculationMode: ''
      };
      this.ruleForm.ruleForm2.push(add);
    },
    removeRow(idx) {
      this.ruleForm.ruleForm2.splice(idx, 1);
    },
    getState() {
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.stateList = res.data.map((item) => {
            return {
              id: item.id,
              label: `${item.nameEn}`
            };
          });
        }
      });
    },
    // 查询
    getSearch() {
      const statusTypeObj = {
        1: this.$t('GlobalSetObj.enable'),
        0: this.$t('GlobalSetObj.stop')
      };
      const data = {
        params: {}
      };
      data.pageSize = this.queryForm.pageSize;
      data.pageNumber = this.queryForm.pageNumber;
      data.params = this.queryForm.params;
      if (this.timeValue && this.timeValue.length > 0) {
        data.params.beginTime = this.timeValue[0];
        data.params.endTime = this.timeValue[1];
      } else {
        data.params.beginTime = null;
        data.params.endTime = null;
      }
      getConfigPage(data).then((res) => {
        if (res.code === 200) {
          this.queryForm.total = res.data.total;
          this.tableData = res.data.records;
          this.tableData.forEach((item) => {
            item.statusTypeObjName = statusTypeObj[item.status];
          });
        }
      });
    },
    addCusTime() {
      this.cusTimeDialogTitle = this.$t('uploadFile.addInternalLeadTime');
      this.merchantIdList = [];
      this.editId = null;
      this.addCusTimeDialog = true;
      if (this.$refs.ruleRef) {
        this.$refs.ruleRef.clearValidate();
      }
    },
    // 点击确定
    cusSubmit(val) {
      if (val === 1) {
        this.addCusTimeDialog = false;
      } else {
        this.$refs['ruleRef'].validate((valid) => {
          if (valid) {
            // 需要校验两个表单
            let isValid = true;
            if (
              this.cusTimeDialogTitle === this.$t('uploadFile.addInternalLeadTime') &&
              this.ruleForm.ruleForm2.length > 0
            ) {
              this.ruleForm.ruleForm2.forEach((item, index) => {
                const fields = [
                  `ruleForm2.${index}.siteState`,
                  `ruleForm2.${index}.agingStartType`,
                  `ruleForm2.${index}.areaType`,
                  `ruleForm2.${index}.duration`
                ];
                if (item.agingStartType !== 1) {
                  fields.push(
                    `ruleForm2.${index}.agingStartState`,
                    `ruleForm2.${index}.agingCalculationMode`
                  );
                }
                fields.forEach(field => {
                  this.$refs['ruleRef'].validateField(field, (errorMessage) => {
                    if (errorMessage) {
                      isValid = false;
                    }
                  });
                });
              });
            }
            if (!isValid) {
              console.log('error');
              return false;
            }
            let formData = [];
            if (this.cusTimeDialogTitle === this.$t('uploadFile.addInternalLeadTime')) {
              formData = [
                {
                  siteState: this.ruleForm.siteState,
                  agingStartType: this.ruleForm.agingStartType,
                  areaType: this.ruleForm.areaType,
                  duration: this.ruleForm.duration,
                  agingStartState: this.ruleForm.agingStartState || null,
                  agingCalculationMode: this.ruleForm.agingCalculationMode || null
                }
              ];
              if (this.ruleForm.ruleForm2.length > 0) {
                formData = formData.concat(
                  this.ruleForm.ruleForm2.map(item => {
                    const dataItem = {
                      siteState: item.siteState,
                      agingStartType: item.agingStartType,
                      areaType: item.areaType,
                      duration: item.duration
                    };
                    if (item.agingStartType !== 1) {
                      dataItem.agingStartState = item.agingStartState;
                      dataItem.agingCalculationMode = item.agingCalculationMode;
                    } else {
                      dataItem.agingStartState = null;
                      dataItem.agingCalculationMode = null;
                    }
                    return dataItem;
                  })
                );
              }
            }
            if (this.cusTimeDialogTitle === this.$t('uploadFile.addInternalLeadTime')) {
              InternalAgingAdd(formData).then((res) => {
                if (res.code === 200) {
                  this.addCusTimeDialog = false;
                  this.$message.success(this.$t('GlobalSetObj.SaveSuccessfully'));
                  this.getSearch();
                }
              });
            } else {
              const form = {
                siteState: this.ruleForm.siteState,
                agingStartType: this.ruleForm.agingStartType,
                areaType: this.ruleForm.areaType,
                duration: this.ruleForm.duration,
                agingStartState: this.ruleForm.agingStartState || null,
                agingCalculationMode: this.ruleForm.agingCalculationMode || null
              };
              form.id = this.editId;
              InternalAgingModify(form).then((res) => {
                if (res.code === 200) {
                  this.addCusTimeDialog = false;
                  this.$message.success(this.$t('GlobalSetObj.SaveSuccessfully'));
                  this.getSearch();
                }
              });
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },
    // 编辑
    editMessage(row) {
      this.cusTimeDialogTitle = this.$t('uploadFile.editInternalLeadTime');
      this.editId = row.id;
      this.ruleForm = {
        siteState: row.siteState,
        agingStartType: row.agingStartType,
        areaType: row.areaType,
        duration: row.duration,
        agingStartState: row.agingStartState,
        agingCalculationMode: row.agingCalculationMode
      };
      this.ruleForm.ruleForm2 = [];
      this.addCusTimeDialog = true;
    },
    // 启用停用
    updateStatus(row) {
      const data = {
        id: row.id,
        status: row.status === 1 ? 0 : 1
      };
      this.$confirm(this.$t('customerManagements.areSureStop'), this.$t('collectionCenter.tips'), {
        confirmButtonText: this.$t('collectionCenter.confirm'), // '确定'
        cancelButtonText: this.$t('collectionCenter.cancel'), // '取消'
        type: 'warning'
      })
        .then(async() => {
          InternalAgingUpdateStatus(data).then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.ModificationSuccessful'));
              this.getSearch();
            }
          });
        })
        .catch(() => {
          console.log('取消关闭');
        });
    },
    // 获取最近一周时间
    getTimer() {
      // 获取当前时间
      const today = dayjs().format('YYYY-MM-DD');
      const oneWeekAgo = dayjs().subtract(1, 'months').format('YYYY-MM-DD');
      this.timeValue = [oneWeekAgo + ' 00:00:00', today + ' 23:59:59'];
    },
    enterSearch() {
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    // 重置
    resetForm() {
      this.queryForm.pageNumber = 1;
      this.timeValue = [];
      // this.getTimer();
      this.queryForm.params = {
        timeType: 1,
        status: null, // 状态：1、启用，2、停用
        siteState: null,
        areaType: null,
        agingStartState: null
      };
      this.getSearch();
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    handleAddCusTimeDialog() {
      this.ruleForm = {
        siteState: '',
        agingStartType: '',
        areaType: '',
        duration: '',
        agingStartState: null,
        agingCalculationMode: null,
        ruleForm2: []
      };
      this.$nextTick(() => {
        if (this.$refs.ruleRef) {
          this.$refs.ruleRef.clearValidate();
        }
      });
    },
    viewVersionHistory(row) {
      getVersionHistoryInternalAging(row.id).then(res => {
        if (res.code === 200) {
          const statusTypeObj = {
            0: this.$t('GlobalSetObj.stop'),
            1: this.$t('GlobalSetObj.enable')
          };
          this.versionHistoryData = (res.data || []).map(item => {
            return {
              ...item,
              statusTypeObjName: statusTypeObj[item.status],
              slaVersionDisplay: item.slaVersionDisplay || (item.slaVersion ? 'V' + Number(item.slaVersion).toFixed(1) : '- -')
            };
          });
          this.versionHistoryDialog = true;
        } else {
          this.$message.error(res.msg || '获取历史版本失败');
        }
      });
    },
    closeVersionHistoryDialog() {
      this.versionHistoryDialog = false;
      this.versionHistoryData = [];
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-class ::v-deep .el-dialog {
  margin-top: 10vh !important;
}
.dialog-class ::v-deep .el-dialog .el-dialog__body {
  padding-left: 0 !important;
  padding-right: 0 !important;
  box-sizing: border-box;
}
.dialog-class ::v-deep .el-dialog__body {
  padding: 0 15px !important;
  max-height: 70vh;
  overflow-y: auto;
}
.footer-stick-class {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  bottom: 0;
  z-index: 10;
}
.required-calss {
  width: 80%;
  margin-left: 10px;
  &::before {
    position: absolute;
    left: -10px;
    top: 50%;
    transform: translateY(-50%);
    content: '*';
    color: #F56C6C;
  }
}
.rule-box-class ::v-deep .el-form-item__label {
  line-height: 14px !important;
}
.row-box-class {
  justify-content: space-between;
  flex-wrap: wrap;
  background: #f2f1f2;
  margin: 0 10px 10px 10px;
  padding: 20px 10px 0 10px;
  box-sizing: border-box;
  position: relative;
}
.closeBtn {
  position: absolute;
  right: 10px;
  top: 10px;
}
::v-deep .el-dialog__body {
  padding: 0 15px;
  padding-bottom: 15px;
}

::v-deep {
  .drawerClass header {
    border-bottom: 1px solid #aaa !important;
    margin-bottom: 0 !important;
    padding: 20px 20px 20px !important;
  }
}

.selectLabel ::v-deep .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  font-weight: bold;
  text-align: left;
}

.selectLabel ::v-deep .el-input__icon {
  line-height: 28px !important;
}

.selectType ::v-deep .el-input--suffix .el-input__inner {
  border: none !important;
  font-weight: bold;
  font-size: 14px;
  text-align: left;
}

.textOperator {
  color: #00A551;
  cursor: pointer;
  font-size: 22px;
}

.textOperator1 {
  color: #f56c6c;
  cursor: pointer;
  font-size: 22px;
}

.messgeList {
  height: 450px;
  background-color: #f5f5f5;
  margin-bottom: 20px;
  border-radius: 10px;
  padding: 10px;
  overflow-y: auto;
}

.downLink {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f7fa;
  cursor: pointer;
  padding: 5px;
  margin-top: 20px;
  box-sizing: border-box;
}

.downModule {
  color: #00A551;
  text-decoration: underline;
  cursor: pointer;
  margin-right: 15px;
}
</style>
